<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'StepCbmecsResolve',
})
</script>
<template>
  <TlDetailItem title="同意-参保名额测算" color="green">
    <TlDetailField label="审核人">{{ record?.createAdminUserObj?.loginName }}</TlDetailField>
    <TlDetailField label="审核时间">{{ record?.createdAt }}</TlDetailField>
    <TlDetailField label="审核意见">{{ record?.shenHeYiJian }}</TlDetailField>
    <TlDetailField label="指标数">
      {{ cbmecsZhiBiaoShu }}
    </TlDetailField>
    <TlDetailField label="复函">
      <FileDisplayNormals :files="cbmecsFuHanFiles" :colAttrs="{ span: 12 }" />
    </TlDetailField>
  </TlDetailItem>
</template>

<script lang="ts" setup name="StepCbmecsResolve">
import { computed } from 'vue'
import { FileDisplayNormals } from '-/Common/FileDisplay'
import TlDetailField from '../common/TlDetailField.vue'
import TlDetailItem from '../common/TlDetailItem.vue'
const props = defineProps<{
  record?: any
}>()
// 指标数
const cbmecsZhiBiaoShu = computed(() => props.record?.files?.cbmecsZhiBiaoShu)
// 复函
const cbmecsFuHanFiles = computed(() => props.record?.files?.cbmecsFuHanFiles ?? [])
</script>
